/* ==========================================================================
   Di Lorenzo — theme JS. No framework, no build step.
   ========================================================================== */
(function(){
  'use strict';
  var $=function(s,r){return (r||document).querySelector(s);};
  var $$=function(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s));};

  /* ---- banner height fills the first screen once the bars above are known -- */
  function measureChrome(){
    var h=0;
    $$('.ann,.hd').forEach(function(el){h+=el.offsetHeight;});
    document.documentElement.style.setProperty('--chrome', h+'px');
  }
  measureChrome();
  addEventListener('resize', measureChrome);
  addEventListener('load', measureChrome);

  /* ---- mobile menu ---- */
  window.dlMenu=function(force){
    var m=$('#mm'), b=$('.ic--m');
    var open = force===0 ? false : m.dataset.open!=='1';
    m.dataset.open=open?'1':'0';
    if(b) b.setAttribute('aria-expanded', open);
  };

  /* ---- banner carousel, only when there is more than one slide ---- */
  $$('.pb').forEach(function(pb){
    var tr=$('.pb__tr',pb), dots=$$('.pb__d button',pb),
        num=$('.pb__num',pb), rail=$('.pb__rail i',pb),
        n=$$('.pb__s',pb).length, i=0, timer;
    if(n<2) return;
    function go(k){
      i=(k+n)%n;
      tr.style.transform='translateX(-'+(i*100)+'%)';
      dots.forEach(function(d,j){d.setAttribute('aria-pressed', j===i);});
      if(num) num.textContent='0'+(i+1)+' / 0'+n;
      if(rail) rail.style.width=((i+1)/n*100)+'%';
    }
    dots.forEach(function(d,j){d.addEventListener('click',function(){go(j);restart();});});
    function restart(){clearInterval(timer);timer=setInterval(function(){go(i+1);},6500);}
    restart();
  });

  /* ---- cart count, live ---- */
  function paintCart(n){
    var c=$('#cart'); if(!c) return;
    c.dataset.n=n;
    c.setAttribute('aria-label','Cart, '+n+(n===1?' item':' items'));
    var t=$('#cartN'); if(t) t.textContent = n>9 ? '9+' : n;
    c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump');
  }
  document.addEventListener('dl:cart',function(e){paintCart(e.detail);});

  /* ---- cart drawer ----
     Add to cart opens the cart itself, on the right, with the confirmation
     inside it. The shopper sees what they just bought, the running total, and
     both ways out, without leaving the page they were reading. ---- */
  var drawer=$('#cartDrawer');
  function money(c){ return '$'+(c/100).toFixed(2); }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g,function(m){
    return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]; }); }

  function paintDrawer(cart){
    if(!drawer) return;
    var lines=$('#cartLines'), foot=$('#cartFoot'), empty=$('#cartEmpty'), sub=$('#cartSub');
    if(!cart.items || !cart.items.length){
      if(lines) lines.innerHTML='';
      if(foot) foot.hidden=true;
      if(empty) empty.hidden=false;
      return;
    }
    if(empty) empty.hidden=true;
    if(foot) foot.hidden=false;
    if(sub) sub.textContent=money(cart.total_price);
    if(lines) lines.innerHTML = cart.items.map(function(it,i){
      var img = it.image ? '<img src="'+esc(it.image)+'" alt="" loading="lazy">' : '';
      var variant = (it.variant_title && it.variant_title!=='Default Title')
        ? '<span class="cdr__v">'+esc(it.variant_title)+'</span>' : '';
      var plan = it.selling_plan_allocation
        ? '<span class="cdr__pl">'+esc(it.selling_plan_allocation.selling_plan.name)+'</span>' : '';
      return '<div class="cdr__l" data-line="'+(i+1)+'">'+
        '<a class="cdr__im" href="'+esc(it.url)+'">'+img+'</a>'+
        '<div class="cdr__d">'+
          '<a class="cdr__n" href="'+esc(it.url)+'">'+esc(it.product_title)+'</a>'+
          variant+plan+
          '<div class="cdr__q">'+
            '<button type="button" class="cdr__qb" data-step="-1" aria-label="One less">&minus;</button>'+
            '<span class="cdr__qn">'+it.quantity+'</span>'+
            '<button type="button" class="cdr__qb" data-step="1" aria-label="One more">+</button>'+
            '<button type="button" class="cdr__rm" data-remove>Remove</button>'+
          '</div>'+
        '</div>'+
        '<span class="cdr__pr">'+money(it.final_line_price)+'</span>'+
      '</div>';
    }).join('');
  }

  function refreshDrawer(then){
    fetch('/cart.js',{headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(cart){
        paintDrawer(cart);
        document.dispatchEvent(new CustomEvent('dl:cart',{detail:cart.item_count}));
        if(then) then(cart);
      }).catch(function(){});
  }

  function openDrawer(msg){
    if(!drawer) return;
    var m=$('#cartMsg');
    if(m) m.hidden = !msg;
    drawer.hidden=false;
    requestAnimationFrame(function(){ drawer.classList.add('cdr--on'); });
    document.documentElement.style.overflow='hidden';
  }
  function closeDrawer(){
    if(!drawer) return;
    drawer.classList.remove('cdr--on');
    document.documentElement.style.overflow='';
    setTimeout(function(){ drawer.hidden=true; },260);
  }

  if(drawer){
    drawer.addEventListener('click',function(e){
      if(e.target.closest('[data-cart-close]')){ closeDrawer(); return; }
      var line=e.target.closest('.cdr__l');
      if(!line) return;
      var idx=line.getAttribute('data-line');
      var step=e.target.closest('.cdr__qb');
      var rm=e.target.closest('[data-remove]');
      if(!step && !rm) return;
      var now=parseInt(($('.cdr__qn',line)||{}).textContent,10)||1;
      var next = rm ? 0 : now + parseInt(step.getAttribute('data-step'),10);
      if(next<0) next=0;
      drawer.classList.add('cdr--busy');
      fetch('/cart/change.js',{method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({line:parseInt(idx,10),quantity:next})})
        .then(function(r){return r.json();})
        .then(function(cart){
          paintDrawer(cart);
          document.dispatchEvent(new CustomEvent('dl:cart',{detail:cart.item_count}));
        })
        .catch(function(){})
        .then(function(){ drawer.classList.remove('cdr--busy'); });
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape' && !drawer.hidden) closeDrawer();
    });
    /* The cart icon opens the drawer rather than the cart page. */
    var icon=$('#cart');
    if(icon) icon.addEventListener('click',function(e){
      e.preventDefault();
      refreshDrawer();
      openDrawer(false);
    });
  }

  /* ---- add to cart without leaving the page ---- */
  $$('form[action$="/cart/add"]').forEach(function(f){
    f.addEventListener('submit',function(e){
      e.preventDefault();
      var btn=$('[type=submit]',f), label=btn?btn.textContent:'';
      if(btn){btn.disabled=true;btn.textContent='Adding…';}
      fetch('/cart/add.js',{method:'POST',body:new FormData(f)})
        .then(function(r){return r.json();})
        .then(function(){return fetch('/cart.js');})
        .then(function(r){return r.json();})
        .then(function(cart){
          document.dispatchEvent(new CustomEvent('dl:cart',{detail:cart.item_count}));
          if(btn){btn.disabled=false;btn.textContent=label;}
          paintDrawer(cart);
          openDrawer(true);
        })
        .catch(function(){ if(btn){btn.disabled=false;btn.textContent=label;} f.submit(); });
    });
  });

  /* ---- product page: subscribe vs one-time, and the free shipping bar ---- */
  $$('.sb').forEach(function(sb){
    var opts=$$('.sb__o',sb), body=$('.sb__body',sb),
        form=sb.closest('form'), price=parseFloat(sb.dataset.price||0),
        off=parseFloat(sb.dataset.off||0.1), free=parseFloat(sb.dataset.free||45);
    function ship(v){
      var bar=$('#shipFill'), txt=$('#shipTxt');
      if(!bar) return;
      var gap=Math.max(0,free-v);
      bar.style.width=Math.min(100,v/free*100)+'%';
      txt.textContent = gap>0
        ? 'Add '+money(gap)+' for free shipping'
        : 'This order ships free';
    }
    function money(v){return '$'+v.toFixed(2);}
    /* Quantity belongs to the one-off purchase. A subscription is one bag on a
       schedule, so the row is hidden and reset when subscribe is chosen. */
    var qty=$('.qr',sb), qtyIn=qty?$('.qr__i',qty):null;
    function showQty(on){
      if(!qty) return;
      qty.hidden = !on;
      if(!on && qtyIn) qtyIn.value = 1;
    }
    opts.forEach(function(o){
      o.addEventListener('click',function(){
        opts.forEach(function(x){x.setAttribute('aria-checked', x===o);});
        if(body) body.style.display = o.dataset.m==='sub' ? '' : 'none';
        var sell=$('input[name="selling_plan"]',form);
        if(sell) sell.value = o.dataset.m==='sub' ? (o.dataset.plan||'') : '';
        showQty(o.dataset.m!=='sub');
        ship(o.dataset.m==='sub' ? price*(1-off) : price);
      });
    });
    var checked=opts.filter(function(x){return x.getAttribute('aria-checked')==='true';})[0];
    showQty(!checked || checked.dataset.m!=='sub');
    ship(price*(1-off));
  });

  /* ---- gallery: arrows, dots and swipe ---- */
  $$('.gal').forEach(function(g){
    var imgs=$$('.gal__i',g), dots=$$('.gal__d button',g), i=0;
    if(imgs.length<2) return;
    function show(k){
      i=(k+imgs.length)%imgs.length;
      imgs.forEach(function(im,j){im.style.display = j===i ? '' : 'none';});
      dots.forEach(function(d,j){d.dataset.on = j===i ? '1':'0';});
    }
    var l=$('.gal__ar--l',g), r=$('.gal__ar--r',g);
    if(l) l.addEventListener('click',function(){show(i-1);});
    if(r) r.addEventListener('click',function(){show(i+1);});
    dots.forEach(function(d,j){d.addEventListener('click',function(){show(j);});});
    var fr=$('.fr',g), x0=null;
    if(fr){
      fr.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
      fr.addEventListener('touchend',function(e){ if(x0===null) return;
        var dx=e.changedTouches[0].clientX-x0; x0=null;
        if(Math.abs(dx)>40) show(i+(dx<0?1:-1)); });
    }
    show(0);
  });

  /* ---- stockist map ----
     Reads a JSON script tag, waits for Leaflet, and only draws if there are
     real coordinates. Everything is guarded: a broken venue row should not
     take the rest of the page down with it. ---- */
  function drawMap(){
    var el=$('#miniMap'), data=$('#dlVenues');
    if(!el || !data) return;
    if(!window.L){ return setTimeout(drawMap, 200); }
    var vs;
    try{ vs=JSON.parse(data.textContent); }catch(e){ return; }
    vs=vs.filter(function(v){
      var la=parseFloat(v.lat), ln=parseFloat(v.lng);
      return la && ln && !isNaN(la) && !isNaN(ln);
    });
    if(!vs.length){ el.style.display='none'; return; }
    var map=L.map('miniMap',{scrollWheelZoom:false,zoomControl:false,dragging:false,
      doubleClickZoom:false,boxZoom:false,keyboard:false,touchZoom:false});
    L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
      {attribution:'&copy; OpenStreetMap &copy; CARTO',maxZoom:19,subdomains:'abcd'}).addTo(map);
    var near=[];
    vs.forEach(function(v){
      var ll=[parseFloat(v.lat),parseFloat(v.lng)];
      if(ll[0]>-34.2) near.push(ll);
      L.marker(ll,{icon:L.divIcon({className:'',html:'<div class="dl-pin"></div>',
        iconSize:[13,13],iconAnchor:[6,12]})}).addTo(map)
        .bindPopup('<b>'+v.n+'</b><br>'+v.a);
    });
    map.fitBounds(near.length?near:vs.map(function(v){
      return [parseFloat(v.lat),parseFloat(v.lng)];}),{padding:[34,34]});
    setTimeout(function(){map.invalidateSize();},120);
    var link=$('#mapLink');
    if(link){ el.style.cursor='pointer';
      el.addEventListener('click',function(){location.href=link.href;}); }
  }
  drawMap();

  /* ---- collection filters ---- */
  var fw=$('#fw');
  if(fw){
    var SEL={size:[],roast:[],use:[],type:[]};
    function render(){
      var cards=$$('#grid .cd'), shown=0;
      cards.forEach(function(c){
        var ok=true;
        for(var ax in SEL){
          if(!SEL[ax].length) continue;
          var have=(c.dataset[ax]||'').split(',');
          if(!SEL[ax].some(function(v){return have.indexOf(v)>-1;})) ok=false;
        }
        c.style.display=ok?'':'none'; if(ok) shown++;
      });
      var n=0; for(var k in SEL) n+=SEL[k].length;
      var cnt=$('#fCount');
      if(cnt) cnt.textContent = shown+' '+(shown===1?'product':'products')+(n?' · '+n+(n===1?' filter':' filters'):'');
      var clr=$('#fClear'); if(clr) clr.classList.toggle('hide', !n);
      var empty=$('#gridEmpty');
      if(empty) empty.innerHTML = shown ? '' :
        '<div class="empty"><p style="margin:0;font-weight:500">Nothing matches those filters</p></div>';
    }
    $$('#fw button').forEach(function(b){
      b.addEventListener('click',function(){
        var ax=b.dataset.ax, v=b.dataset.v, arr=SEL[ax], i=arr.indexOf(v);
        i<0?arr.push(v):arr.splice(i,1);
        b.setAttribute('aria-pressed', i<0);
        render();
      });
    });
    var clr=$('#fClear');
    if(clr) clr.addEventListener('click',function(){
      for(var k in SEL) SEL[k]=[];
      $$('#fw button').forEach(function(b){b.setAttribute('aria-pressed','false');});
      render();
    });
    render();
  }
})();

/* Pause control for looping background videos. */
document.addEventListener('click',function(e){
  var btn=e.target.closest('[data-vb-toggle]'); if(!btn) return;
  var v=btn.closest('section').querySelector('video'); if(!v) return;
  var pause='<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><rect x="6" y="5" width="4" height="14" fill="currentColor"/><rect x="14" y="5" width="4" height="14" fill="currentColor"/></svg>';
  var play='<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true"><path d="M7 4.5v15l13-7.5z" fill="currentColor"/></svg>';
  if(v.paused){ v.play(); btn.setAttribute('aria-label','Pause video'); btn.innerHTML=pause; }
  else { v.pause(); btn.setAttribute('aria-label','Play video'); btn.innerHTML=play; }
});

/* Accordions on phones, everything open on a desktop. */
function accBuild(){
  var mob=matchMedia('(max-width:760px)').matches;
  document.querySelectorAll('[data-acc]').forEach(function(sec){
    var body=sec.querySelector('.acc__b'); if(!body) return;
    var bar=sec.querySelector('.acc__h');
    if(mob){
      if(!bar){
        bar=document.createElement('button');
        bar.className='acc__h'; bar.type='button';
        bar.innerHTML='<span>'+(sec.dataset.acc||'')+'</span><i aria-hidden="true"></i>';
        bar.setAttribute('aria-expanded','false');
        bar.addEventListener('click',function(){
          var on=sec.classList.toggle('acc--on');
          bar.setAttribute('aria-expanded',on);
        });
        body.parentNode.insertBefore(bar, body);
      }
      sec.classList.add('acc');
    } else {
      sec.classList.remove('acc','acc--on');
      if(bar) bar.remove();
    }
  });
}
accBuild();
addEventListener('resize',accBuild);

/* The home range advances on its own on a phone until it is touched. */
(function(){
  var el=document.querySelector('.dl-autocar, #blendCar');
  if(!el || !matchMedia('(max-width:760px)').matches) return;
  var stop=false, t=setInterval(function(){
    if(stop) return;
    var first=el.firstElementChild, w=first?first.offsetWidth+14:200;
    var end=el.scrollWidth-el.clientWidth-4;
    el.scrollTo({left: el.scrollLeft>=end?0:el.scrollLeft+w*2, behavior:'smooth'});
  },4200);
  ['touchstart','pointerdown','wheel'].forEach(function(ev){
    el.addEventListener(ev,function(){stop=true;clearInterval(t);},{passive:true,once:true});
  });
})();

/* First-order popup. */
(function(){
  var md=document.getElementById('promoMd'); if(!md) return;
  var seen=false; try{ seen=localStorage.getItem('dl_promo')==='1'; }catch(e){}
  if(seen) return;
  function open(){ md.hidden=false; document.body.style.overflow='hidden'; removeEventListener('scroll',fire); }
  function close(){ md.hidden=true; document.body.style.overflow=''; try{ localStorage.setItem('dl_promo','1'); }catch(e){} }
  function fire(){ if(window.scrollY>600) open(); }
  addEventListener('scroll',fire,{passive:true});
  setTimeout(function(){ if(md.hidden) open(); }, 25000);
  md.querySelectorAll('[data-promo-close]').forEach(function(b){ b.addEventListener('click',close); });
})();

/* Carousels get a rail and a swipe label on phones. */
function carHints(){
  var mob=matchMedia('(max-width:760px)').matches;
  document.querySelectorAll('.car').forEach(function(el){
    var next=el.nextElementSibling;
    var has=next && next.classList && next.classList.contains('car__bar');
    if(!mob){ if(has) next.remove(); return; }
    if(has) return;
    var bar=document.createElement('div');
    bar.className='car__bar';
    bar.innerHTML='<span class="car__rail"><i></i></span><span class="car__t">Swipe &rarr;</span>';
    el.parentNode.insertBefore(bar, el.nextSibling);
    var fill=bar.querySelector('i');
    function upd(){
      var max=el.scrollWidth-el.clientWidth;
      var p=max>0?el.scrollLeft/max:0;
      fill.style.transform='scaleX('+(0.3+p*0.7)+')';
      bar.classList.toggle('car__bar--end', p>0.97);
    }
    el.addEventListener('scroll',upd,{passive:true});
    upd();
  });
}
carHints();
addEventListener('resize',carHints);

/* Barista directory: filtering happens in the page, so it stays instant. */
(function(){
  var list=document.getElementById('dirList'); if(!list) return;
  var q=document.getElementById('dirQ'), ex=document.getElementById('dirExp'),
      av=document.getElementById('dirAvail'), none=document.getElementById('dirNone'),
      count=document.getElementById('dirCount');
  var cards=[].slice.call(list.querySelectorAll('.dir__c'));
  function apply(){
    var s=(q&&q.value||'').trim().toLowerCase(), e=ex&&ex.value||'', a=av&&av.value||'', n=0;
    cards.forEach(function(c){
      var ok = (!s || (c.dataset.name+' '+c.dataset.suburb).indexOf(s)>-1)
            && (!e || c.dataset.exp===e)
            && (!a || (c.dataset.avail||'').indexOf(a)>-1);
      c.hidden=!ok; if(ok) n++;
    });
    if(none) none.hidden = n>0;
    if(count) count.textContent = n;
  }
  [q,ex,av].forEach(function(el){ if(el) el.addEventListener('input',apply); });
  apply();
})();
